
const config = {
  apiBaseUrl: process.env.REACT_APP_BACKEND_BASE_URL || "/api",
  enableGoogleLogin:
    process.env.REACT_APP_ENABLE_GOOGLE_LOGIN !== undefined
      ? process.env.REACT_APP_ENABLE_GOOGLE_LOGIN === "true"
      : true,
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  },
};

export default config;
